import { GetClinicalDocs } from '~/domain/usecases/clinicalDocs/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteGetClinicalDocs implements GetClinicalDocs {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetClinicalDocs.Model>;

  constructor(url: string, httClient: HttpClient<GetClinicalDocs.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: GetClinicalDocs.Params,
  ): Promise<GetClinicalDocs.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.docId}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
